// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { PrivateRoute } from './components/PrivateRoute';
import { useAuth0, Auth0Provider } from '@auth0/auth0-react';
import { UserControls } from './components/UserControls';
import { BrokerConnections } from './components/Connections/BrokerConnections';
import { Charts } from "./components/Charts";
import { Admin } from './components/Admin';
import { AlgoMetrics } from './components/AlgoMetrics';
import { ErrorBoundary } from './components/ErrorBoundary';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';
import { Footer } from './components/Footer';
import { hasTenant } from './utils/Permissions';
import { TENANT_INVESTCEO } from './utils/constants';
import { TermsPage, PrivacyPage } from './components/Legal';
import { determineTenant } from './utils/tenants';

function App() {
  const { loading } = useAuth0();

  useEffect(() => {
    if (determineTenant() === 'smithfield') {
      document.title = 'Smithfield Trading';
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = `${process.env.PUBLIC_URL}/smithfield/logo.png`;
      const description = document.querySelector("meta[name='description']");
      if (description) {
        description.content = 'Web site for Smithfield Trading';
      }
    }
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const getCallbackURL = () => {
    if (window.location.pathname.includes('/trade/')) {
      return `${window.location.origin}/connect`;
    } else {
      return `${window.location.origin}${window.location.pathname}`;
    }
  }

  return (
    <ErrorBoundary>
      <Auth0Provider
        domain={process.env.REACT_APP_IAM_DOMAIN}
        clientId={process.env.REACT_APP_IAM_CLIENT_ID}
        authorizationParams={{
          redirect_uri: getCallbackURL(),
          audience: process.env.REACT_APP_IAM_AUDIENCE
        }}
        cacheLocation={process.env.NODE_ENV === 'development' ? 'localstorage' : 'memory'}
      >
        <BrowserRouter>
          <div className="App flex flex-col min-h-screen">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/legal/terms" element={<TermsPage />} />
                <Route path="/legal/privacy" element={<PrivacyPage />} />
                <Route path="*" element={
                  <PrivateRoute>
                    <Routes>
                      <Route path="/connect" element={<BrokerConnections />} />
                      <Route path="/trade" element={<UserControls />} />
                      <Route path="/trade/*" element={<UserControls />} />
                      <Route path="/performance" element={hasTenant(TENANT_INVESTCEO) ? <Charts /> : <Navigate to="/connect" replace />} />
                      <Route path="/metrics" element={<AlgoMetrics />} />
                      <Route path="/admin" element={<Admin />} />
                      <Route path='*' element={<Navigate to='/connect' />} />
                    </Routes>
                  </PrivateRoute>
                } />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </Auth0Provider>
    </ErrorBoundary>
  );
}

export default App;